<template>
  <div class="aj-calendar">
    <filterDateMonth
      v-model="currentMonth"
      style="padding-left: 1rem;margin-bottom: 0.625rem"
    ></filterDateMonth>
    <van-calendar
      :poppable="false"
      :show-confirm="false"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="new Date(value)"
      @select="selectCalendar"
      color="#3775ff"
      :formatter="formatter"
    ></van-calendar>
  </div>
</template>

<script>
import filterDateMonth from "./filterDateMonth.vue";
import moment from "moment";
export default {
  components: {
    filterDateMonth,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentMonth: moment(this.value).format("YYYY-MM"),
    };
  },
  watch: {
    value() {
      this.currentMonth = moment(this.value).format("YYYY-MM");
    },
  },
  computed: {
    minDate() {
      return new Date(
        moment(this.currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD")
      );
    },
    maxDate() {
      if (
        new Date(
          moment(this.currentMonth)
            .endOf("month")
            .format("YYYY-MM-DD")
        ) <= new Date()
      ) {
        return new Date(
          moment(this.currentMonth)
            .endOf("month")
            .format("YYYY-MM-DD")
        );
      } else {
        return new Date();
      }
    },
  },
  methods: {
    formatter(data){

      if(moment(data.date).day()==0||moment(data.date).day()==6){
        data.className="isWeekend"
      }
      return data
    },
    selectCalendar(data) {
      this.$emit("input", moment(data).format("YYYY-MM-DD"));
      this.$emit("change", moment(data).format("YYYY-MM-DD"));
    },
  },
};
</script>

<style lang="scss" scoped>
.aj-calendar {
  ::v-deep.van-calendar {
    .van-calendar__header {
      .van-calendar__header-title {
        display: none;
      }
      .van-calendar__header-subtitle {
        display: none;
      }
      .van-calendar__weekday {
        color: #999;
      }
    }
    .van-calendar__body {
      overflow: hidden;
      .van-calendar__day {
        font-weight: bold;
      }
      .isWeekend {
        color: #888;
      }
      .van-calendar__day--disabled{
        color: #c8c9cc;
      }
    }
  }
}
</style>
